//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import {
  IBatchCreateConnection,
  IBatchCreateConnectionConfig,
} from '@apis/universal-posts/connections/universalPostConnectionModel';
import { isDefined } from '@utils/filterPredicates';
import { Serialized, SerializedArray } from '@utils/types/Serialized';

export const deserializeBatchCreateConnectionConfig = (
  serializedConfig: Serialized<IBatchCreateConnectionConfig>,
): IBatchCreateConnectionConfig => {
  return {
    ...serializedConfig,
    batchScheduledTime: isDefined(serializedConfig.batchScheduledTime)
      ? new Date(serializedConfig.batchScheduledTime)
      : undefined,
  };
};

export const deserializeBatchCreateConnection = (
  serializedConnection: Serialized<IBatchCreateConnection>,
): IBatchCreateConnection => {
  return {
    ...serializedConnection,
    config: isDefined(serializedConnection.config)
      ? deserializeBatchCreateConnectionConfig(serializedConnection.config)
      : undefined,
    configuration: isDefined(serializedConnection.configuration)
      ? deserializeBatchCreateConnectionConfig(
          serializedConnection.configuration,
        )
      : undefined,
  };
};

export const deserializeConnectionArray = (
  serializedArray?: SerializedArray<IBatchCreateConnection>,
): IBatchCreateConnection[] => {
  return serializedArray?.map(deserializeBatchCreateConnection) ?? [];
};
